export const POLYGON = {
	id: 1,
	reference: 'polygon',
	label: 'Polygone',
	geoJsonType: 'Polygon',
	urn: '$:map:feature_type:1',
};

export const RECTANGLE = {
	id: 5,
	reference: 'rectangle',
	label: 'Rectangle',
	geoJsonType: 'Polygon',
	urn: '$:map:feature_type:5',
};

export const CIRCLE = {
	id: 4,
	reference: 'circle',
	label: 'Cercle',
	geoJsonType: 'LineString',
	urn: '$:map:feature_type:4',
};

const featureTypes = [
	POLYGON,
	{
		id: 2,
		reference: 'point',
		label: 'Point',
		geoJsonType: 'Point',
		urn: '$:map:feature_type:2',
	},
	{
		id: 3,
		reference: 'line',
		label: 'Ligne',
		geoJsonType: 'LineString',
		urn: '$:map:feature_type:3',
	},
	CIRCLE,
	RECTANGLE,
	{
		id: 6,
		reference: 'square',
		label: 'Carré',
		geoJsonType: 'Polygon',
		urn: '$:map:feature_type:6',
	},
];

export const featureTypeByUrn = featureTypes.reduce<Record<string, typeof featureTypes[number]>>((acc, item) => {
	acc[item['urn']] = item;
	return acc;
}, {});

export const featureTypeByReference = featureTypes.reduce<Record<string, typeof featureTypes[number]>>((acc, item) => {
	acc[item['reference']] = item;
	return acc;
}, {});

export default featureTypes;